export const required = (v) => (v != null && v !== '') || 'Campo requerido'
